import React, { useState, useEffect } from 'react'
import { Outlet, useNavigate, useLocation } from 'react-router-dom'

import Sidebar from '../layouts/Sidebar'
import Tabs from '../components/ui/Tabs'
import AnnouncementService from "../services/AnnouncementService"


function Announcement() {

    // Announcements
    const [announcements, setAnnouncements] = useState([]);
    const [drills, setDrills] = useState([]);
    const location = useLocation();
    const navigate = useNavigate();

    const loadAnnouncements = async () => {
        try {
            let response = await AnnouncementService.findAll(1, 100);
            if (response && response.status === 200) {
                setDrills(response.data.filter(({drill})=>drill==true));
                setAnnouncements(response.data.filter(({drill})=>drill==false));
            }
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        loadAnnouncements();
    }, [location.pathname]);

    const activeTab = location.pathname.endsWith('/drills') ? 'drills' : 'announcements';

    const Header = () => (
        <Tabs
            tabs={[
                { value: 'announcements', label: 'Announcements' },
                { value: 'drills', label: 'Drills' },
            ]}
            active={activeTab}
            onChange={(value) => navigate(value === 'drills' ? 'drills' : '')}
        />
    );

    return (
        <Sidebar title="Announcements" header={<Header />}>
            <Outlet context={[announcements, drills]}/>
        </Sidebar>
    )
}

export default Announcement
